import { ThemeSelectors, TypeDiscovery, TypeFiesta } from '@at/design-system-foundation'
import { PictogramAvoidingScams } from '@at/design-system-pictograms'
import styled, { css } from 'styled-components'
import { Button } from '@at/design-system-elements'

export const SomethingWentWrongContainer = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
`

export const Icon = styled(PictogramAvoidingScams)``

export const Title = styled(TypeDiscovery)`
    margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
`

export const Description = styled.div`
    margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
`

export const Paragraph = styled(TypeFiesta).attrs({ as: 'p' })``

export const ModalButtonContainer = styled.div`
    ${({ theme }) => {
        return css`
            & > button.atds-button {
                color: ${theme.color.button.bgFill.contrast.default};
                padding: ${ThemeSelectors.getLegacyGridUnit(theme)}px ${ThemeSelectors.getLegacyGridUnit(theme) * 2}px;
            }
            display: flex;
            justify-content: center;
        `
    }}
`
export const ModalButton = styled(Button)`
    clear: both;
    display: block;
    margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
`
